import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal';
import QuickActionPresetForm from './QuickActionPresetForm';

export default function QuickActionPresetModal({
  isOpen,
  onClose,
  actions,
  cards,
  preset,
  onSave,
}) {
  const handleSave = (nextPreset) => {
    onSave(nextPreset);
    onClose();
  };

  return (
    <Modal isVisible={isOpen} onClose={onClose}>
      <div className="quick-action-preset-modal">
        <QuickActionPresetForm
          actions={actions}
          cards={cards}
          preset={preset}
          onSave={handleSave}
          onCancel={onClose}
        />
      </div>
    </Modal>
  );
}

QuickActionPresetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,
  cards: PropTypes.arrayOf(PropTypes.object).isRequired,
  preset: PropTypes.object,
  onSave: PropTypes.func.isRequired,
};
